import { FormBuilderBasicInputModel } from './form-builder-basic-input-model';
import { Type } from 'class-transformer';
import { FormBuilderSectionPermissionModel } from './form-builder-section-permission-model';

export class FormBuilderSectionModel {
    public label: string;
    
    public title?: string;

    // Available types: default & prebuild
    public type: string = 'default';

    // Used when type = prebuild
    public subtype: string;

    public hasChanges: boolean = false;

    public active: boolean = false;

    public readonly: boolean = false;

    // This Type is used to inform `plainToClass` which Class to cast the `components` property
    @Type(() => FormBuilderBasicInputModel)
    public components: FormBuilderBasicInputModel[] = [];
    
    // This Type is used to inform `plainToClass` which Class to cast the `permissions` property
    @Type(() => FormBuilderSectionPermissionModel)
    public permissions: FormBuilderSectionPermissionModel[] = [];

    constructor(label: string) {
        this.label = label;
    }

    addComponent(component: FormBuilderBasicInputModel): void {
        this.components.push(component);
    }

    removeComponent(component: FormBuilderBasicInputModel): void {
        this.components.splice(this.components.findIndex((item) => {
            if (item === component) {
                return true;
            }
        }), 1)
    }

    hasComponent(component: FormBuilderBasicInputModel): boolean {
        const elIndex = this.components.findIndex((item: FormBuilderBasicInputModel) => {
            return item === component;
        });

        return elIndex !== -1;
    }

    addPermission(permission: FormBuilderSectionPermissionModel): void {
        this.permissions.push(permission);
    }

    removePermission(permission: FormBuilderSectionPermissionModel): void {
        this.permissions.splice(this.permissions.findIndex((item) => {
            if (item.tag === permission.tag && item.permission === permission.permission) {
                return true;
            }
        }), 1);
    }

    hasPermission(permission: FormBuilderSectionPermissionModel): boolean {
        this.permissions.map((item: FormBuilderSectionPermissionModel) => {
            if (item.tag === permission.tag && item.permission === permission.permission) {
                return true;
            }
        });

        return false;
    }

    getComponentType(index: number): string {
        return this.components[index]?.type || '';
    }

    setAsActive(status: boolean): void {
        this.active = status;
    }

    setAsReadonly(status: boolean): void {
        this.readonly = status;
    }

    setTitle(title: string): void {
        this.title = title;
    }

    setType(type: string): void {
        this.type = type;
    }

    setSubtype(subtype: string): void {
        this.subtype = subtype;
    }

    setAsTouched(status: boolean): void {
        this.hasChanges = status;
    }

    setChildComponentsAsActive(status: boolean): void {
        this.components.map((component: FormBuilderBasicInputModel) => {
            component.active = status;
        });
    }
}